import * as React from 'react';
import { createBrowserRouter, Navigate, Outlet, RouteObject, RouterProvider } from 'react-router-dom';
import MainContexts from '@/contexts/main-context';
import MainLayout from '@/layouts/main-layout/main-layout';
import LoggedPage from '@/pages/logged-page/logged-page';
import CampaignPage from '@/pages/campaign-page/campaign-page';
import MissionPageV2 from '@/pages/mission-page-v2/mission-page-v2';
import CollectiblePage from '@/pages/collectible-page/collectible-page';
import CollectionPage from '@/pages/collection-page/collection-page';
import ActivityPage from '@/pages/activity-page/activity-page';
import WalletPage from '@/pages/wallet-page/wallet-page';
import BenefitPage from '@/pages/benefit-page/benefit-page';
import LoginPage from '@/pages/login-page/login-page';
import RedeemGiftPage from '@/pages/redeem-gift-page/redeem-gift-page';
//import ScannerPage from '@/pages/scanner-page/scanner-page';
import SendGiftPage from '@/pages/send-gift-page/send-gift-page';
import ProtectedLayout from '@/layouts/protected-layout/protected-layout';
import ConfigurationPage from '@/pages/configuration-page/configuration-page';
import CompleteProfilePage from '@/pages/complete-profile/complete-profile';
import TermsAndConditionsPage from '@/pages/terms-and-conditions-page/terms-and-conditions-page';
import PrivacyPolicyPage from '@/pages/privacy-policy-page/privacy-policy-page';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <MainContexts />,
    children: [
      {
        path: '',
        element: <MainLayout />,
        children: [
          { path: '', element: 
            <ProtectedLayout isPrivate={false}>
              <LoggedPage /> 
            </ProtectedLayout>},
          { path: 'home', element: 
            <ProtectedLayout isPrivate={false}>
              <LoggedPage /> 
            </ProtectedLayout>},
          { path: 'campaign/:campaignId', element: 
            <ProtectedLayout isPrivate={false}>
              <CampaignPage /> 
            </ProtectedLayout>},
          { path: 'mission/:campaignId/:missionId', element: 
            <ProtectedLayout isPrivate={false}>
              <MissionPageV2 /> 
            </ProtectedLayout>},
          { path: 'send-gift/:rewardId', element: 
            <ProtectedLayout isPrivate={false}>
              <SendGiftPage /> 
            </ProtectedLayout>},
          { path: 'collection/:collectionId', element: 
            <ProtectedLayout isPrivate={false}>
              <CollectionPage /> 
            </ProtectedLayout>},
          { path: 'collectible/:collectibleId', element: 
            <ProtectedLayout isPrivate={false}>
              <CollectiblePage /> 
            </ProtectedLayout>},
          { path: 'benefit/:contract_address/:contract_type_id', element: 
            <ProtectedLayout isPrivate={false}>
              <BenefitPage /> 
            </ProtectedLayout>},
          { path: 'register', element: 
            <ProtectedLayout isPrivate={true}>
              <CompleteProfilePage />
            </ProtectedLayout>},
          {
            path: 'wallet', element:
            <ProtectedLayout isPrivate={true}>
              <Outlet />
            </ProtectedLayout>,
            children: [
              { path: '', element: <WalletPage /> },
              { path: 'history', element: <ActivityPage /> },
              { path: 'configuration', element: <ConfigurationPage /> },
            ]
          },
          /*{ path: 'scanner', element: 
            <ProtectedLayout isPrivate={true}>
              <ScannerPage /> 
            </ProtectedLayout>
          },*/
        ],
      },
      {
        path: 'login', 
        element: <MainLayout variant='appBg' />,
        children: [{ path: '', element: 
          <ProtectedLayout isPrivate={false}>
            <LoginPage /> 
          </ProtectedLayout>
        }],
      },
      {
        path: 'terms-and-conditions',
        element: <MainLayout/>,
        children: [{ path: '', element: <TermsAndConditionsPage /> }],
      },
      {
        path: 'privacy-policy',
        element: <MainLayout/>,
        children: [{ path: '', element: <PrivacyPolicyPage /> }],
      },
      {
        path: 'redeem-gift/:contract_address/:code',
        element: <MainLayout/>,
        children: [{ path: '', element: <RedeemGiftPage /> }],
      },
    ],
  },
  { path: '*', element: <Navigate to="/" replace />},
]

const AppRouter: React.FC = () => {
  const router = createBrowserRouter(routes, {
    future: {
      v7_relativeSplatPath: true,
      v7_fetcherPersist: true,
      v7_normalizeFormMethod: true,
      v7_partialHydration: true,
      v7_skipActionErrorRevalidation: true,
    },
  });


  return <RouterProvider router={router} />;
};

export default AppRouter;